import { useEffect } from 'react'
import { LOGINFO_LOCALSTORAGE_KEY } from 'redesign/constants'
import { useLogInfoStore } from 'redesign/store'
import { LogInfoProps, AccessType } from 'typings/logInfo'

export const useLogInfo = () => {
    const { logInfo, setLogInfo } = useLogInfoStore()

    // Carrega os dados do localStorage quando o hook é inicializado
    useEffect(() => {
        const savedLogInfo = localStorage.getItem(LOGINFO_LOCALSTORAGE_KEY)
        if (savedLogInfo) {
            setLogInfo(JSON.parse(savedLogInfo))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Atualiza o localStorage sempre que logInfo for alterado
    useEffect(() => {
        if (logInfo) {
            localStorage.setItem(LOGINFO_LOCALSTORAGE_KEY, JSON.stringify(logInfo))
        }
    }, [logInfo])

    const getAccessType = (): AccessType => {
        const userAgent = navigator.userAgent.toLowerCase()
        return /mobile|android|iphone|ipad|ipod/i.test(userAgent) ? AccessType.WEBMOBILE : AccessType.WEBDESK
    }

    const getUserAgent = () => {
        const userAgent = navigator.userAgent.toLowerCase()
        return userAgent
    }

    const getGeolocation = (): Promise<{
        geolocation: string
        accepted: boolean
    }> =>
        new Promise(resolve => {
            const { geolocation } = navigator

            if (!geolocation) {
                resolve({ geolocation: '', accepted: false })
                return
            }

            geolocation.getCurrentPosition(
                position => {
                    resolve({
                        geolocation: `${position.coords.latitude}, ${position.coords.longitude}`,
                        accepted: true,
                    })
                },
                () => {
                    resolve({ geolocation: '', accepted: false })
                },
            )
        })

    const getIpAddress = async (): Promise<string> => {
        try {
            const response = await fetch('https://api.ipify.org/?format=json')
            const data = await response.json()
            return data.ip
        } catch {
            return ''
        }
    }

    const addLogInfo = async () => {
        try {
            const [geo, ip] = await Promise.all([getGeolocation(), getIpAddress()])

            const updatedValue: LogInfoProps = {
                accessType: getAccessType(),
                userAgent: getUserAgent(),
                ipAddress: ip,
                geolocation: geo.geolocation,
                accepted: geo.accepted,
            }

            setLogInfo(updatedValue)
        } catch (error) {
            console.error('Erro ao adicionar log info:', error.message)
        }
    }

    return {
        addLogInfo,
        logInfo,
    }
}
